import { defineMessages } from 'react-intl';

export default defineMessages({
  frameAlt: {
    id: 'component.storyboard.frameAlt',
    defaultMessage: 'Storyboard frame {frame}',
  },
  frameLabel: {
    id: 'component.storyboard.frameLabel',
    defaultMessage: 'Frame {frame}',
  },
  frameLabelWithTime: {
    id: 'component.storyboard.frameLabelWithTime',
    defaultMessage: 'Frame {frame} · ~{time}',
  },
  frameRetry: {
    id: 'component.storyboard.frameRetry',
    defaultMessage: 'Retry',
  },
  frameFailed: {
    id: 'component.storyboard.frameFailed',
    defaultMessage: "Couldn't load",
  },
  stripSummary: {
    id: 'component.storyboard.stripSummary',
    defaultMessage: '{shown, number} of {count, number} frames, spread across the video',
  },
  stripSummaryAll: {
    id: 'component.storyboard.stripSummaryAll',
    defaultMessage: '{count, plural, one {# frame} other {# frames}}',
  },
  viewAll: {
    id: 'component.storyboard.viewAll',
    defaultMessage: 'View all {count, number} frames',
  },
  openViewer: {
    id: 'component.storyboard.openViewer',
    defaultMessage: 'Open storyboard',
  },
  viewerTitle: {
    id: 'component.storyboard.viewerTitle',
    defaultMessage: 'Storyboard',
  },
  viewerCount: {
    id: 'component.storyboard.viewerCount',
    defaultMessage: '{count, plural, one {# frame} other {# frames}}',
  },
  timesApproximate: {
    id: 'component.storyboard.timesApproximate',
    defaultMessage: 'Times are approximate.',
  },
  goToFrame: {
    id: 'component.storyboard.goToFrame',
    defaultMessage: 'Go to frame',
  },
  go: {
    id: 'component.storyboard.go',
    defaultMessage: 'Go',
  },
  backToGrid: {
    id: 'component.storyboard.backToGrid',
    defaultMessage: 'All frames',
  },
  previous: {
    id: 'component.storyboard.previous',
    defaultMessage: 'Previous frame',
  },
  next: {
    id: 'component.storyboard.next',
    defaultMessage: 'Next frame',
  },
  singleFramePosition: {
    id: 'component.storyboard.singleFramePosition',
    defaultMessage: 'Frame {frame, number} of {count, number}',
  },
  keyboardHint: {
    id: 'component.storyboard.keyboardHint',
    defaultMessage: '← → to step, Esc for all frames',
  },
  setAsThumbnail: {
    id: 'component.storyboard.setAsThumbnail',
    defaultMessage: 'Set as thumbnail',
  },
  settingThumbnail: {
    id: 'component.storyboard.settingThumbnail',
    defaultMessage: 'Setting thumbnail…',
  },
  thumbnailSet: {
    id: 'component.storyboard.thumbnailSet',
    defaultMessage:
      'Thumbnail updated to frame {frame, number}. Links used outside FileSpin may show the previous image for up to 2 days.',
  },
  thumbnailFailed: {
    id: 'component.storyboard.thumbnailFailed',
    defaultMessage: 'Could not set the thumbnail. Please try again.',
  },
  isThumbnail: {
    id: 'component.storyboard.isThumbnail',
    defaultMessage: '✓ Asset thumbnail',
  },
});
